import React from 'react'

const Title = ({ title }) => {
  return <div className="title-item">{title}</div>
}

export default Title
